<template>
    <div>
        <template v-if="manage_administrator == true && companies != null && roles != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Administrators</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form @submit.prevent="editAdministrator()">
                        <div class="tab-content-inner">
                                <div class="user-permissions">
                                    <div class="form-group">
                                    <label> Company </label>
                                    <select v-model="form.company_id" data-live-search="true" name="company_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null"  @change="CompanyIdChange">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Name </label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Mobile No. </label>
                                    <input v-model="form.mobile_no" type="number" name="mobile_no" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> CNIC </label>
                                    <input v-model="form.cnic" type="number" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> E-Mail Address </label>
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group btn-holder">
                                    <div class="label-holder"> </div>
                                    <button class="btn btn-default" type="button" v-on:click="generatePassword" style="padding:0 20px;">Generate new password</button>
                                </div>
                                <div class="form-group">
                                    <label> Password </label>
                                    <input v-model="password" :type="fieldTypes.password" id="password" name="password" placeholder="Password must contain Uppercase,Lowercase,Digits,Special characters Example: 42-aBcdef" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" @focus="handleType" @blur="handleType" autocomplete="off">
                                    <i class="far fa-eye" id="togglePassword" @click="togglePassword()"></i>
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Confirm Password </label>
                                    <input v-model="form.password_confirmation" type="password" name="password_confirmation" id="password_confirmation" class="form-control" :class="{ 'is-invalid': form.errors.has('password_confirmation') }"  autocomplete="off">
                                    <has-error :form="form" field="password_confirmation"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Join Date </label>
                                    <datepicker name="join_date" v-model="form.join_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('join_date') }"></datepicker>
                                    <has-error :form="form" field="join_date"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Temp User </label>
                                    <select v-model="form.temp_user" name="temp_user" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('temp_user') }" >
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                    </select>
                                    <has-error :form="form" field="temp_user"></has-error>
                                </div>
                                <label class="label block-label"> <span class="highlight-color"> Role </span> </label>
                                <div class="form-group">
                                    <select v-on:change="getPermission($event)" v-model="form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('role_id') }" v-if="roles != null">
                                        <option value="" selected>Select Role</option>
                                        <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="role_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <template v-if="permissions != null">
                                        <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                            <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                            <div class="permissions-box">
                                                <div class="row">
                                                    <div class="col-md-4 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                        <label class="check-holder ml-0">
                                                            <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                            <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="modal fade" id="getSharedCompanies" tabindex="-1" role="dialog" aria-labelledby="SharedCompanies" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-body text-left p-1">
                                                <div>
                                                    <!-- Modal Header -->
                                                    <div class="modal-header">
                                                        <label class="label block-label"> Select Sub / Child companies to Share Ledger </label>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="modal-body">
                                                        <div class="alert alert-danger" v-if="errorMessage!==''">{{errorMessage}}</div>
                                                        <template v-if="sharedCompanies.length != 0">
                                                            <div class="form-group" v-for="(sharedCompany, index) in sharedCompanies" v-bind:key="sharedCompany.id">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> {{sharedCompany.name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="sharedCompany.name"></i>
                                                                    <input type="checkbox" v-bind:value="sharedCompany.id" v-model="form.selectedSharedCompanies" @change="UpdateCompanies" />
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            No Sub/Child Company Found!
                                                        </template>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="modal-footer p-1">
                                                        <div class="row normal-ib-space mt-3">
                                                            <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                                            <div class="col"> <button :disabled="form.busy" class="btn btn-primary active"> Submit </button> </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="page-top mb-1 mb-3 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/administrators" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>

                        </div>

                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="manage_administrator === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_administrator === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    company_id : '',
                    mobile_no : '',
                    cnic : '',
                    name : '',
                    email : '',
                    password : '',
                    password_confirmation : '',
                    join_date : new Date(),
                    temp_user:'',
                    role_id : '',
                    rolePermissions : [],
                    userPermissions : [],
                    selectedSharedCompanies: [],
                    updatedSharedCompanies: []
                }),
                password:'',
                role : {},
                permissions : null,
                category : null,
                companies: null,
                roles: null,
                manage_administrator: null,
                sharedCompanies: [],
                errorMessage: '',
                fieldTypes: {
                    password: 'text',
                }
            }
        },
        methods: {
            CompanyIdChange: function(val, oldVal) {
                this.form.selectedSharedCompanies = [];
                this.form.updatedSharedCompanies = [];
            },
            UpdateCompanies() {
                this.form.updatedSharedCompanies = this.form.selectedSharedCompanies;
            },
            editAdministrator() {
                this.$Progress.start();
                this.form.put('/api/updateAdministrator')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == 201) {
                            this.form.updatedSharedCompanies = this.form.selectedSharedCompanies;
                            this.sharedCompanies = res.data.companies;
                            $('#getSharedCompanies').modal('show');    
                            this.showToastBox('warning',res.data.message);
                        } else {
                            $('#getSharedCompanies').modal('hide');      
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            this.$router.push('/administrators');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getPermission(event) {
                this.$Progress.start();
                axios.get('/api/getRolePermissionData/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.form.rolePermissions = [];
                        $.each(res.data.permissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                            this.form.userPermissions = this.form.rolePermissions;
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load permissions');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load permissions');
                });
            },
            generatePassword() {
                var specials = '!$#%@*+^=_-';
                var lowercase = 'abcdefghijklmnopqrstuvwxyz';
                var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                var numbers = '0123456789';

                var all = specials + lowercase + uppercase + numbers;

                String.prototype.pick = function(min, max) {
                    var n, chars = '';

                    if (typeof max === 'undefined') {
                        n = min;
                    } else {
                        n = min + Math.floor(Math.random() * (max - min));
                    }

                    for (var i = 0; i < n; i++) {
                        chars += this.charAt(Math.floor(Math.random() * this.length));
                    }

                    return chars;
                };

                // Credit to @Christoph: http://stackoverflow.com/a/962890/464744
                String.prototype.shuffle = function() {
                    var array = this.split('');
                    var tmp, current, top = array.length;

                    if (top) while (--top) {
                        current = Math.floor(Math.random() * (top + 1));
                        tmp = array[current];
                        array[current] = array[top];
                        array[top] = tmp;
                    }

                    return array.join('');
                };

                var retVal = (specials.pick(2) + lowercase.pick(8) + uppercase.pick(3)+ numbers.pick(3) ).shuffle();
                this.password = retVal;
                this.form.password_confirmation = retVal;
                return false;
            },
            getEditAdministratorData(){
                axios.get('/api/editAdministrator/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.user.id;
                        this.form.company_id = res.data.user.company_id;
                        this.form.email = res.data.user.email;
                        this.form.mobile_no = res.data.user.mobile_no;
                        this.form.cnic = res.data.user.cnic;
                        this.form.name = res.data.user.name;
                        this.form.join_date = res.data.user.joining_date;
                        this.form.temp_user = res.data.user.temp_user;
                        this.form.role_id = res.data.userRole.id;
                        this.companies = res.data.companies;
                        this.roles = res.data.roles;
                        this.permissions = res.data.permissions;
                        this.form.selectedSharedCompanies = res.data.selectedSharedCompanies;
                        $.each(res.data.userPermissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            togglePassword(){
                const togglePassword = document.querySelector('#togglePassword');
                const password = document.querySelector('#password');
                const cpassword = document.querySelector('#password_confirmation');
                const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                cpassword.setAttribute('type', type);
                // toggle the eye / eye slash icon
                togglePassword.classList.toggle('fa-eye-slash');
            },
            handleType(event) {
                const { srcElement, type } = event;
                const { name, value } = srcElement;
                if(type === 'blur' && !value) {
                    this.fieldTypes[name] = 'text'
                } else {
                    this.fieldTypes[name] = 'password'
                }
            }
        },
        updated(){
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_administrator|edit_administrator').then(result => {
                this.manage_administrator = (result.manage_administrator && result.edit_administrator);
            }).then(result => {
                if(this.manage_administrator == true){
					this.getEditAdministratorData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
           
        },
         watch: {
			password: function() {
				//do something when the data changes.
                this.password=this.password.replace(/\s/g, "");
					this.form.password=this.password;
			}
		}
    }
    
</script>
